import { Component, inject } from "@angular/core";
import { BrandingService } from "./branding.service";

@Component({
    selector: "lhs-mipro-logo",
    template: `
        <div *ngIf="service.showMiProBranding()" class="logo" rte="14E"></div>
    `
})
export class LHSMiproLogoComponent {
    protected readonly service = inject(BrandingService);
}